import { Container, Col, Row } from "react-bootstrap";
import ProjectCards from "../../../utils/project-cards";
import { useContent } from "../../../hooks/useContent";
import { useExternalMedia } from "../../../hooks/useExternalMedia";



type Props = {};

const RowTwo = (props: Props) => {


  const { serviceImg1, serviceImg2, serviceImg3, serviceImg4 } = useExternalMedia()
  const { truncatedBrandDesign, truncatedHrTech, truncatedProductDevelopment, truncatedServiceOperations } = useContent()


  return (
    <Container>
      <Row
      >
        <Col
          xs={12}
          md={6}
          lg={6}
        >
          <ProjectCards
            cardTitle="Service Operations"
            imgSrc={serviceImg1}
            cardText={truncatedServiceOperations}
            projectName={"Eraconneckt project"}
            link=""
          />
        </Col>

        <Col
          xs={12}
          md={6}
          lg={6}
        >
          <ProjectCards
            cardTitle="HR Technology"
            imgSrc={serviceImg2}
            cardText={truncatedHrTech}
            projectName={"Eraconneckt project"}
            link=""
          />
        </Col>

        <Col
          xs={12}
          md={6}
          lg={6}
        >
          <ProjectCards
            cardTitle="Product Development"
            imgSrc={serviceImg3}
            cardText={truncatedProductDevelopment}
            projectName={"Eraconneckt project"}
            link=""
          />
        </Col>

        <Col
          xs={12}
          md={6}
          lg={6}>
          <ProjectCards
            cardTitle="Brand Design"
            imgSrc={serviceImg4}
            cardText={truncatedBrandDesign}
            projectName={"Eraconneckt project"}
            link=""
          />
        </Col>
      </Row>
    </Container>
  );
};

export default RowTwo;
